import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

export interface Coleccion{
  auth_key:string,
  data:[{
    id:number,
    nombre:string,
    descripcion:string
  }]
}

@Injectable({
  providedIn: 'root'
})
export class ColeccionService {

  constructor(private http: HttpClient) { }



  getAll(idt){
    var headers = new HttpHeaders();
    const options = {headers: headers,withCredintials: false };
    let postData = [];
    postData.push({'auth_key':idt});
    return this.http.post<Coleccion>(environment.urlColeccion+'?opcion=1', JSON.stringify(postData));
  }

  
}
